import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CreateTenantComponent} from './create-tenant.component';


const routes: Routes = [
  {
    path: '',
    component: CreateTenantComponent,
    children: []
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateTenantRoutingModule {
}
